import { useState } from 'react';

const indexItems = [
  {
    id: 1,
    title: '热门电影',
    desc: '最新院线大片、经典高分电影一网打尽',
    icon: 'ri-movie-2-line',
    color: 'primary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20collage%20with%20warm%20dramatic%20lighting%2C%20film%20strip%20elements%2C%20golden%20and%20coral%20tones%2C%20modern%20minimal%20style%2C%20clean%20composition%2C%20entertainment%20concept&width=640&height=400&seq=idx-01-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '热播剧集',
    desc: '国产剧、韩剧、美剧每日同步追更',
    icon: 'ri-tv-2-line',
    color: 'accent',
    imageUrl: 'https://readdy.ai/api/search-image?query=Television%20series%20drama%20visual%20with%20warm%20atmospheric%20lighting%2C%20modern%20TV%20screen%20elements%2C%20amber%20and%20soft%20beige%20tones%2C%20minimalist%20design%2C%20clean%20aesthetic%2C%20entertainment%20concept&width=640&height=400&seq=idx-02-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '经典重温',
    desc: '那些年我们追过的经典，百看不厌',
    icon: 'ri-vidicon-2-line',
    color: 'secondary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20film%20aesthetic%20with%20warm%20nostalgic%20tones%2C%20retro%20movie%20elements%2C%20soft%20golden%20lighting%2C%20elegant%20minimal%20composition%2C%20timeless%20cinema%20concept&width=640&height=400&seq=idx-03-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '动作大片',
    desc: '肾上腺素飙升的动作爽片合集',
    icon: 'ri-shield-flash-line',
    color: 'primary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20visual%20with%20dramatic%20warm%20lighting%20effects%2C%20motion%20blur%20elements%2C%20intense%20coral%20and%20deep%20red%20tones%2C%20cinematic%20style%2C%20clean%20modern%20design&width=640&height=400&seq=idx-04-2026&orientation=landscape',
  },
  {
    id: 5,
    title: '喜剧精选',
    desc: '开心一笑，释放压力的欢乐时光',
    icon: 'ri-emotion-laugh-line',
    color: 'accent',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20comedy%20film%20visual%20with%20warm%20sunny%20lighting%2C%20playful%20elements%2C%20soft%20yellow%20and%20amber%20tones%2C%20minimalist%20modern%20style%2C%20happy%20entertainment%20concept&width=640&height=400&seq=idx-05-2026&orientation=landscape',
  },
  {
    id: 6,
    title: '悬疑惊悚',
    desc: '烧脑剧情，步步紧逼的心跳体验',
    icon: 'ri-ghost-line',
    color: 'secondary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20thriller%20film%20visual%20with%20moody%20warm%20lighting%2C%20shadow%20play%20elements%2C%20deep%20amber%20and%20dark%20coral%20tones%2C%20minimalist%20suspenseful%20atmosphere%2C%20clean%20composition&width=640&height=400&seq=idx-06-2026&orientation=landscape',
  },
  {
    id: 7,
    title: '动画动漫',
    desc: '热门国漫日漫，二次元精彩世界',
    icon: 'ri-palette-line',
    color: 'primary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20animation%20visual%20with%20vibrant%20warm%20lighting%2C%20illustrated%20style%20elements%2C%20soft%20pastel%20coral%20and%20peach%20tones%2C%20modern%20minimal%20design%2C%20creative%20concept&width=640&height=400&seq=idx-07-2026&orientation=landscape',
  },
  {
    id: 8,
    title: '纪录纪实',
    desc: '真实故事，深度探索世界万象',
    icon: 'ri-earth-line',
    color: 'accent',
    imageUrl: 'https://readdy.ai/api/search-image?query=Documentary%20film%20visual%20with%20natural%20warm%20lighting%2C%20world%20exploration%20elements%2C%20earthy%20amber%20and%20soft%20golden%20tones%2C%20minimalist%20clean%20style%2C%20educational%20concept&width=640&height=400&seq=idx-08-2026&orientation=landscape',
  },
  {
    id: 9,
    title: '最新上映',
    desc: '抢先观看每周最新上线影片',
    icon: 'ri-sparkling-line',
    color: 'primary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fresh%20new%20release%20movie%20visual%20with%20bright%20warm%20spotlight%20effect%2C%20premiere%20elements%2C%20vibrant%20coral%20and%20gold%20tones%2C%20modern%20minimal%20style%2C%20exciting%20cinema%20concept&width=640&height=400&seq=idx-09-2026&orientation=landscape',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            精选热门分类，涵盖电影、电视剧、动漫等丰富内容，轻松发现你想看的
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <IndexCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function IndexCard({ item }: { item: typeof indexItems[0] }) {
  const [imgError, setImgError] = useState(false);

  const colorMap: Record<string, { bg: string; iconBg: string; iconColor: string }> = {
    primary: { bg: 'bg-primary-50', iconBg: 'bg-primary-100', iconColor: 'text-primary-500' },
    accent: { bg: 'bg-accent-50', iconBg: 'bg-accent-100', iconColor: 'text-accent-600' },
    secondary: { bg: 'bg-secondary-50', iconBg: 'bg-secondary-100', iconColor: 'text-secondary-500' },
  };

  const colors = colorMap[item.color] || colorMap.primary;

  return (
    <div className={`group rounded-xl ${colors.bg} overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer`}>
      <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
        {!imgError ? (
          <img
            src={item.imageUrl}
            alt={item.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            onError={() => setImgError(true)}
          />
        ) : null}
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent pointer-events-none"></div>
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <div className={`w-8 h-8 rounded-lg ${colors.iconBg} flex items-center justify-center`}>
            <i className={`${item.icon} ${colors.iconColor} text-base`}></i>
          </div>
          <h3 className="text-sm md:text-base font-semibold text-foreground-900">{item.title}</h3>
        </div>
        <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
      </div>
    </div>
  );
}